<!-- 物理因素接触限值微波 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所微波职业接触限值</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="typeSort" label="类别">
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型">
      </el-table-column>
      <el-table-column align="center" prop="dailyDose" label="日剂量（μW·h/cm2）">
        <template slot='header'>
          <span>日剂量（μW·h/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="electricIntensity" label="电场强度（V/m）">
      </el-table-column>
      <el-table-column align="center" prop="averagePowerDensity" label="8h平均功率密度（μW/cm2）">
        <template slot='header'>
          <span>8h平均功率密度（μW/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="noAveragePowerDensity" label="非8h平均功率密度（μW/cm2）">
        <template slot='header'>
          <span>非8h平均功率密度（μW/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="shortTimeContactPowerDensity" label="短时间接触功率密度（mW/cm2）">
        <template slot='header'>
          <span>短时间接触功率密度（mW/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.findMicrowave()
    },
    methods:{
      async findMicrowave(){
        let res = await this.$axios.get(this.$serviceAPI.findMicrowave)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/microwave.vue